module.exports = __webpack_public_path__ + "img/icone_reglages.3bb057dd.svg";